export const MODULE = 'config'

export const FETCH_CONFIG_REQUEST = `${MODULE}/FETCH_CONFIG_REQUEST`
export const FETCH_CONFIG_SUCCESS = `${MODULE}/FETCH_CONFIG_SUCCESS`
export const FETCH_CONFIG_FAIL = `${MODULE}/FETCH_CONFIG_FAIL`

export const CLEAR_CONFIG = `${MODULE}/CLEAR`

export const FETCH_CONFIG_RESOURCE = `${MODULE}/FETCH_CONFIG`



// WEBPACK FOOTER //
// ./src/modules/config/constants.js